import Chart from 'chart.js';
export default {
    render: function render(createElement) {
        return createElement('div', {
            style: this.styles,
            class: this.cssClasses
        }, [createElement('canvas', {
            attrs: {
                id: this.chartId,
            },
            ref: 'canvas'
        })]);
    },
    props: {
        chartId: {
            default: 'line-chart',
            type: String
        },
        cssClasses: {
            type: String,
            default: ''
        },
        styles: {
            type: Object
        },
        plugins: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            _chart: null,
            _plugins: this.plugins
        };
    },
    methods: {
        addPlugin: function addPlugin(plugin) {
            this.$data._plugins.push(plugin);
        },
        renderChart: function renderChart(data, options) {
            this.$data._chart = new Chart.Line(this.$refs.canvas.getContext('2d'), {
                data: data,
                options: options,
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.$data._chart) {
            this.$data._chart.destroy();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./vue/src/components/charts/Line.js
// module id = 594
// module chunks = 0